import styled from 'styled-components';

export const TitleWrapper = styled.div`
  width: 401px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: stretch;
`;

export const Title = styled.div`
  word-break: break-all;
  cursor: pointer;
  :hover {
    text-decoration-line: underline;
  }
`;

export const TagWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CompanyTagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TopicTagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TitleImgContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-self: stretch;
`;

export const Img = styled.img`
  object-fit: cover;
  border-radius: 2px;
  width: 142px;
  height: 80px;
`;
